import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface otbookingParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface otbooking { 
    additionalSurgeryId?:any;
    otBookingId?:number;
    otScheduleId?:number;
    otBookingNumber:string;
    otBookingDate?:any;
    otBookingBy: string;
    otPlanSurgeryStartDateTime: any;  
    otPlanSurgeryEndDateTime: any;  
    otSurgeryId:number;
    diagnosisNotes: string;
    surgeryType: string;
    operationType: string;
    otPriority:number;
    departmentId?: string;
    chiefSurgeonId?: string;
    specialComments: string;
    otCancelFlag: string;
    otCancelReason: string;
    otstatusflag: string;
    otBookedFor: string; 
    otTableNumber:number;
    otTheatreId:number; 
    regId: string;
    ipId:number;
    internalDepName:any;
    createdDate:any;
    createdBy:string;
    updatedDate:any;
    updatedBy:string;
    createdIP:string; 
    updatedIP:string;
    tenantId: string;
    branchId: string;
    admissionId?:number;

    parameters?: otbookingParameter[];
    links?: any;
    complication?:string;
}


export abstract class otbookingData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<otbooking[]>;
    abstract create(url: string, data: otbooking): Observable<otbooking[]>;
    abstract update(url: string, data: otbooking): Observable<otbooking>;
}
